import { Box, Container, Stack, Typography, styled } from '@mui/material';
import React from 'react';

import { ZapFastIcon } from '@/assets/icons/ZapFastIcon';

const SectionWrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(12, 0),
  backgroundColor: theme.palette.common.white,
}));

const VisionLabel = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  fontWeight: 600,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(1),
}));

const VisionHeading = styled(Typography)(({ theme }) => ({
  fontFamily: '"Nohemi", sans-serif !important',
  fontWeight: 600,
  fontSize: '1.875rem',
  color: '#181D27',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    fontSize: '2.25rem',
  },
}));

const VisionText = styled(Typography)(({ theme }) => ({
  fontSize: '1.125rem',
  lineHeight: 1.6,
  color: '#535862',
}));

const IconContainer = styled(Box)(({ theme }) => ({
  width: '56px',
  height: '56px',
  borderRadius: '28px',
  backgroundColor: '#FFF4F3',
  border: '8px solid #FFE7E3',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.primary.main,
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  borderRadius: theme.spacing(1),
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    zIndex: 1,
  },
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
}));

const OurVisionSection: React.FC = () => (
  <SectionWrapper>
    <Container maxWidth="lg">
      <Stack direction={{ xs: 'column-reverse', md: 'row' }} spacing={4}>
        <Box sx={{ flex: 1 }}>
          <ImageContainer>
            <img src="/assets/images/aboutus/vision-image.jpg" alt="Our Vision" />
          </ImageContainer>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box sx={{ p: { xs: 3, md: 6 } }}>
            <IconContainer>
              <ZapFastIcon />
            </IconContainer>

            <VisionLabel>Our Vision</VisionLabel>

            <VisionHeading>How we see the market</VisionHeading>

            <VisionText>
              At Terr.ai, we envision a future where property management is effortless, intelligent,
              and accessible to everyone. Our AI-powered platform transforms complex
              property-related tasks into simple, streamlined processes, empowering property
              managers and owners to focus on what truly matters - delivering exceptional service
              and value.
            </VisionText>
          </Box>
        </Box>
      </Stack>
    </Container>
  </SectionWrapper>
);

export default OurVisionSection;
